import { CommonModule } from "@angular/common";
import { NgModule } from '@angular/core';;
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { NgSelectModule } from "@ng-select/ng-select";
import { AgentGoalDetailComponent } from "./agent-goal-detail.component";
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { GaugeModule } from 'angular-gauge';
@NgModule({
    declarations:[
        AgentGoalDetailComponent,
    ],
    exports:[
        AgentGoalDetailComponent,
    ],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        NgSelectModule,
        NgbTooltipModule,
        GaugeModule.forRoot(),
    ]
})

export class AgentGoalDetailModule { }